export const simpleTaskDeadLineNotifyReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'SET':
      localStorage.setItem('simpleTaskDeadLineNotify', JSON.stringify(payload));
      return payload;
    case 'GET':
      return JSON.parse(localStorage.getItem('simpleTaskDeadLineNotify'));
    default:
      return state;
  }
};
